import { Component, ElementRef, ViewChild, OnInit, Input, EventEmitter, AfterViewInit, ChangeDetectorRef, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { RouterModule, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TabsComponent } from '../tabs/tabs.component';
import { NavLinksService } from '../service/nav-links.service';
import { UserService } from '../service/user.service';
import { SidebarService } from '../service/sidebar.service';
import { MenuService } from '../service/menu.service';
import { Subscription } from 'rxjs';
import { StateService } from '../service/state.service';
import { LoginService } from '../service/login.service';
import { AlertPopupComponent } from '../pages/popups/alert-popup/alert-popup.component';
import { NoticesServiceService } from '../service/notices-service.service';
import { ClientNameService } from '../service/client-name.service';
import { environment } from '../environments/environment';
import { ReduxApiHandlerService } from '../service/state-api-handler.service';
import { AdobeViewerComponent } from '../components/adobe-viewer/adobe-viewer.component';
import { CommonService } from '../service/common.service';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { ENTITY_DROPDOWN_ROLES } from '../service/plausible-analytics.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterModule, CommonModule, TabsComponent, AlertPopupComponent, AdobeViewerComponent, SpinnerComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, AfterViewInit, OnChanges {
  public navLinks: any[] = [];
  @Input() sidebarToggle?: EventEmitter<void>;
  sidebarToggleSubscription?: Subscription;
  userId: number = 0;
  Role: string = '';
  currentRoute?: string;
  CustomerId: number = 0;
  firstName?: string;
  lastName?: string;
  ClientId?: string;
  clientName?: string;
  SpID!: any;
  sidebarActive = true;
  toggleimg = '../assets/vectors/SidebarToggleoff.svg'
  logoImageUrl = './assets/Images/TeamLeaseRegtech_Logo_new.png';
  logoImageClass = 'nav-open-logo';
  svgIcon = `../assets/vectors/Reports.svg`;
  isFirstLogin = true;
  isEntityFirst = true;
  CustomerName = '';
  isActive: boolean = false;
  subscription!: Subscription;
  // Router event subscriptions — must be torn down in ngOnDestroy. The layout sits inside
  // *ngIf="showContent" in app.component.html, so it is destroyed/recreated as the user moves
  // between content and Login/Error routes. Without unsubscribing, each recreation leaves a
  // live router.events subscription behind, so NavigationEnd (and loadSidebarLinks →
  // GetMenuBasedOnRole) fires once per stacked subscription.
  routerEventsSub?: Subscription;
  routerEntitySub?: Subscription;
  alertData = { alertMessage: '', alertVisible: '' }
  sidebarTabMenuToggle = false;
  entityText: string = '';
  showProfileDropdown: boolean = false;
  token: any
  selectedMenu: any
  selectedNavLink: any
  helpDocBlob: Blob | null = null;
  loading = false;



  toggleProfileDropdown() {
    this.showProfileDropdown = !this.showProfileDropdown;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.profile-container') && !target.closest('.toggle-Profile')) {
      this.showProfileDropdown = false;
    }
  }
  collapseSidebarSublistsOnSidebarToggle() {
    if (this.sidebarActive === true) {
      this.collapseRootGroups();
    } else {
      const route = this.currentRoute ?? '';
      const root = this.navLinks.find((node: any) => node.autoOpenRoutes?.includes(route));
      if (root) {
        this.expandedMenuIds.add(root.menuID);
      }
    }
  }

  onSidebarTabDownArrayClick(node: any) {

    if (!this.userService.getClientId() && (this.Role == 'HMGR' || this.Role == 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Select Entity is Required', alertVisible: 'error' }
      return;
    }
    this.toggleRootGroup(node);
  }

  // A root with its own page, or drawn in the Workspace style, goes through
  // onSidebarLinkClick exactly like a plain link (which also toggles it); a pure group
  // without an hrefurl only toggles.
  onRootParentClick(node: any) {
    if (node.viaLinkClick) {
      this.onSidebarLinkClick(node.clickKey, node.clickUrl, node);
    } else {
      this.onSidebarTabDownArrayClick(node);
    }
  }

  isExpanded(node: any): boolean {
    return this.expandedMenuIds.has(node.menuID);
  }

  toggleNestedGroup(node: any) {
    if (!this.expandedMenuIds.delete(node.menuID)) {
      this.expandedMenuIds.add(node.menuID);
    }
  }

  trackByMenuId(_: number, node: any) {
    return node.menuID;
  }

  // Opening a root group closes the other root groups; nested groups keep their state.
  private toggleRootGroup(node: any) {
    const wasOpen = this.expandedMenuIds.has(node.menuID);
    this.collapseRootGroups();
    if (!wasOpen) {
      this.expandedMenuIds.add(node.menuID);
    }
  }

  private collapseRootGroups(styleVariant?: string, except?: any) {
    this.navLinks.forEach((node: any) => {
      if (node.menuID !== except?.menuID && (!styleVariant || node.styleVariant === styleVariant)) {
        this.expandedMenuIds.delete(node.menuID);
      }
    });
  }

  // Menu ids of the groups currently expanded, roots and nested groups alike.
  expandedMenuIds = new Set<string>();

  // Roots drawn in the Workspace style when they have children; every other parent uses the
  // sublist style. autoOpenRoutes are extra routes (besides the children's own hrefurls) that
  // re-open the group when the sidebar is expanded.
  private readonly workspaceStyleRoots: { [menuID: string]: { autoOpenRoutes?: string[] } } = {
    M04: {},
    // The Auditor flow continues on /AuditReturnsActivity, which is not a menu row.
    M40: { autoOpenRoutes: ['/AuditReturnsActivity'] },
  };

// Events Masters shows its pending-event count to CORDN.
  private readonly pendingBadge = { menuID: 'M46', role: 'CORDN' };

  // Existing CSS classes for each style, so both looks render from the same generic template.
  private readonly sublistGroupCss = {
    wrapper: '',
    item: 'nav-links-item', itemExpanded: 'expanded',
    link: 'nav-links-item-a', icon: 'nav-link-icons', content: '',
    name: 'links-name', toggle: 'nav-link-toggle-btn', toggleExpanded: 'expanded',
    submenu: 'test', submenuExpanded: 'expanded',
    container: 'nav-sublist-container', containerHeight: 'auto',
    list: 'nav-sublist', childItem: 'nav-sublist-item'
  };
  private readonly sidebarCss: any = {
    workspace: {
      rootGroup: {
        wrapper: '',
        item: 'workspace-nav-item', itemExpanded: 'workspace-nav-item-expanded',
        link: 'workspace-nav-link', icon: 'workspace-nav-icon', content: 'workspace-link-content',
        name: 'workspace-link-name', toggle: 'workspace-nav-toggle', toggleExpanded: 'workspace-nav-toggle-expanded',
        submenu: 'workspace-submenu', submenuExpanded: 'workspace-submenu-expanded',
        container: 'workspace-submenu-container', containerHeight: null,
        list: 'workspace-submenu-list', childItem: 'workspace-submenu-item'
      },
      nestedGroup: {
        wrapper: 'returns-activity-wrapper',
        item: 'returns-activity-item', itemExpanded: 'returns-activity-item-expanded',
        link: 'returns-activity-link', icon: 'returns-activity-icon', content: 'returns-activity-content',
        name: 'returns-activity-name', toggle: 'returns-activity-toggle', toggleExpanded: 'returns-activity-toggle-expanded',
        submenu: 'er1-returns-submenu', submenuExpanded: 'er1-returns-submenu-expanded',
        container: 'er1-returns-container', containerHeight: null,
        list: 'er1-returns-list', childItem: 'er1-returns-item'
      },
      leaf: { link: 'er1-returns-link', icon: 'er1-returns-icon', name: 'er1-returns-name' }
    },
    sublist: {
      rootGroup: this.sublistGroupCss,
      nestedGroup: this.sublistGroupCss,
      leaf: { link: 'sublist-item', icon: 'sublist-nav-link-icons', name: '' }
    }
  };

  // Turns the flat menu rows into a tree via parentMenuID. A null/blank parentMenuID is a
  // root; a child whose parent is absent from the response (inactive, or not mapped to this
  // role) is dropped rather than promoted to a root.
  private buildSidebarTree(rows: any[]): any[] {
    const byMenuId = new Map<string, any>();
    rows.forEach((row: any) => {
      if (row?.menuID && !byMenuId.has(row.menuID)) {
        byMenuId.set(row.menuID, { ...row, children: [] });
      }
    });

    const roots: any[] = [];
    byMenuId.forEach((node: any) => {
      const parentId = (node.parentMenuID ?? '').toString().trim();
      if (!parentId) {
        roots.push(node);
      } else {
        byMenuId.get(parentId)?.children.push(node);
      }
    });

    return this.finalizeNodes(roots, null, new Set<string>());
  }

  // Decorates one level of the tree. `root` is the level-1 ancestor, null while decorating
  // the roots themselves. Roots keep the API order (the SP's ordering); children are
  // ordered by level. Nodes on a parent cycle are never reachable from a root, and
  // `visited` guards the recursion regardless.
  private finalizeNodes(nodes: any[], root: any, visited: Set<string>): any[] {
    const ordered = root
      ? [...nodes].sort((a: any, b: any) => (Number(a.level) || 0) - (Number(b.level) || 0))
      : nodes;

    return ordered
      .filter((node: any) => !visited.has(node.menuID))
      .map((node: any) => {
        visited.add(node.menuID);
        const styleVariant = root ? root.styleVariant : (this.workspaceStyleRoots[node.menuID] ? 'workspace' : 'sublist');
        const css = this.sidebarCss[styleVariant];
        node.styleVariant = styleVariant;
        node.groupCss = root ? css.nestedGroup : css.rootGroup;
        node.leafCss = css.leaf;

        node.children = this.finalizeNodes(node.children, root ?? node, visited);
        node.children.forEach((child: any) => {
          child.itemCss = node.groupCss.childItem;
        });
        node.hasChildren = node.children.length > 0;

        const extraRoutes = !root && node.hasChildren ? this.workspaceStyleRoots[node.menuID]?.autoOpenRoutes ?? [] : [];
        node.clickKey = node.name;
        node.clickUrl = node.hrefurl;
        node.viaLinkClick = styleVariant === 'workspace' || !!node.hrefurl;
        node.routerLink = styleVariant === 'workspace' && node.clickUrl ? node.clickUrl : null;
        node.autoOpenRoutes = !root && node.hasChildren && styleVariant === 'workspace'
          ? [...this.collectHrefs(node.children), ...extraRoutes]
          : [];
        node.forceActive = node.name === 'Dashboard';
        node.showPendingBadge = this.Role === this.pendingBadge.role && node.menuID === this.pendingBadge.menuID;
        node.showName = node.menuID !== this.pendingBadge.menuID;
        return node;
      })
      // A group left with no children renders as a plain link if it has a page, else not at all.
      .filter((node: any) => node.hasChildren || !!node.hrefurl);
  }

  private collectHrefs(nodes: any[]): string[] {
    return nodes.flatMap((node: any) => [node.hrefurl, ...this.collectHrefs(node.children)]).filter(Boolean);
  }

  constructor(
    private navLinksService: NavLinksService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
    private menuService: MenuService,
    private stateService: StateService,
    private editNoticeService: NoticesServiceService,
    private CommonService: CommonService,
    private ClientName: ClientNameService,
    private cd: ChangeDetectorRef,
    private reduxApiHandler: ReduxApiHandlerService
  ) { }

  @ViewChild('sidebar', { static: true }) sidebar!: ElementRef;

  ngOnInit(): void {
    // window.addEventListener('popstate', this.onBackClick.bind(this));

    setTimeout(() => {
      if (!sessionStorage.length && this.router.url != "/Login") {
        this.logOut();
      }
    }, 5000);
    this.AssignSession();
    this.ClientName.currentClientName$.subscribe(clientName => {
      // Blank the label regardless of what any screen pushes into the ClientName service
      // when it must not show for this role/customer combination.
      this.clientName = this.hideEntityLabel ? '' : clientName;
    })

    this.SpID = this.userService.getServiceProviderID();
    if (this.currentRoute == '/CustomerMasters' || this.currentRoute == "/UserMaster" || this.currentRoute == "/CustomerUserMapping" || this.currentRoute == "/ListOfEntities") {
      this.sidebarActive = false;
    }
    this.currentRoute = this.router.url;
    if (this.isFirstLogin) {
      this.toggleSidebar(true);
      this.isFirstLogin = false;
    }

    const allowedRoles = [
      'LSA', 'BT', 'LFT', 'RCP', 'SDEXE', 'CORDN', 'SME', 'HMGR', 'HAPPR',
      'HRL', 'HRLN', 'HRN', 'TLMGT', 'TLACM', 'TLOPH', 'TLCOM', 'TLOPL',
      'TLRM', 'CORDH', 'TLRCH', 'TLAUD'
    ];

    if (allowedRoles.includes(this.Role)) {
      this.sidebarActive = true;
      this.AssignSession();
      this.loadSidebarLinks();
      this.toggleSidebar(false);
    }
    this.routerEventsSub = this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {

          this.currentRoute = this.router.url;
          if (this.currentRoute.split('?')[0] == '/Auth' || this.currentRoute == '/EntityDashboard' || this.currentRoute == "/ClientDashboard") {

            if (this.currentRoute == '/EntityDashboard') {
              this.navLinks = [];
              this.toggleSidebar(true);
              this.CustomerName = '';
              this.ClientId = '';
            }
            else if (this.currentRoute == '/ClientDashboard') {
              this.AssignSession();
              this.loadSidebarLinks();
              this.toggleSidebar(false);
            }
            this.AssignSession();
          }
          else if (this.currentRoute !== '/EntityDashboard' && this.currentRoute !== '/CustomerMasters' && this.currentRoute !== '/UserMaster' && this.currentRoute !== '/CustomerUserMapping' && this.currentRoute !== '/ListOfEntities' && this.Role !== 'SDEXE' && this.Role !== 'RCP' && this.Role !== 'CORDN' &&
            this.Role !== 'SME' && this.currentRoute !== '/EntityMasters' && this.currentRoute !== '/ActivityCalenders' && this.currentRoute !== '/AgreementDetail'
            && this.currentRoute !== '/CommercialMappings' && this.currentRoute !== '/MasterScopings' && this.currentRoute !== '/EntityAddEdit' && this.currentRoute !== '/CustomerAddEdit'
            && this.currentRoute !== '/EntityBulkUpload' && this.currentRoute !== '/MasterScopingEdit' && this.currentRoute !== '/CommercialMappingEdit' && this.currentRoute !== '/StateBillingMaster'
            && this.currentRoute !== '/StateBillingMasterEdit' && sessionStorage.getItem('IsRedirectToMW') != '1' && sessionStorage.getItem('IsRedirectToHM') != '1') {
            this.AssignSession();
            this.loadSidebarLinks();
            this.toggleSidebar(false);
            if (this.userService.getClientId()) {
              this.ClientId = `[${this.userService.getClientId()}]`;
              this.CustomerName = this.userService.getClientName();
            }
          }
          else if (this.Role === 'SDEXE' || this.Role === 'RCP' || this.Role === 'CORDN' || this.Role === 'SME') {
            this.AssignSession();
            this.loadSidebarLinks();
            this.toggleSidebar(false);
            this.CustomerName = '';
            this.ClientId = '';
          }
          else {
            this.navLinks = [];
            this.toggleSidebar(true);
            this.CustomerName = '';
            this.ClientId = '';
          }
          if (this.currentRoute !== '/ListofHolidays' && this.currentRoute != '/ListofHolidaysNotifications') {
            sessionStorage.removeItem('payloadMinimumWages');
          }
          if (this.currentRoute !== '/DocumentGeneration' && this.currentRoute != '/Workspace') {
            sessionStorage.removeItem('month');
            sessionStorage.removeItem('year');
            sessionStorage.removeItem('Input');
            sessionStorage.removeItem('complianceType');
            sessionStorage.removeItem('JsonId');
            sessionStorage.removeItem('formValues');
          }
          this.cdr.detectChanges();
        }
        if (['LSA', 'CORDN', 'BT', 'LFT'].includes(this.Role)) {
          this.ClientId = '';
          this.CustomerName = '';
        }
        this.cdr.detectChanges();
      }

    );
    if (this.isFirstLogin) {
      this.toggleSidebar(true);
      this.isFirstLogin = false;
    }
    this.subscription = this.stateService.isEnabled$.subscribe((value: boolean) => {
      this.isActive = value;
    });
    this.cdr.detectChanges();
    this.editNoticeService.entity$.subscribe(entity => {
      if (entity) {
        this.entityText = entity.text;
      } else {
        this.entityText = '';
      }
    });

    this.routerEntitySub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.router.url === '/NoticeDetails' || this.router.url === '/SMEResponse' || this.router.url === '/SDEXENotice' || this.router.url === '/NoticeDocumentSection') {
          const entity = this.editNoticeService.getEntity();
          this.entityText = entity ? entity.text : '';
        } else {
          this.entityText = '';
        }

        // Route-level RBAC is now enforced before activation by authRouteGuard
        // (src/app/guards/auth-route.guard.ts), so the restricted component never
        // renders first. The old post-render role check that lived here has been
        // removed to keep a single source of truth.
      }
    });

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sidebarToggleSubscription = this.sidebarService.sidebarToggle$.subscribe(() => {
        this.toggleSidebar(!this.sidebarActive);
      });
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.SpID = this.userService.getServiceProviderID();
  }

  ngOnDestroy() {
    this.sidebarToggleSubscription?.unsubscribe();
    this.subscription?.unsubscribe();
    // Tear down the router event subscriptions so a recreated layout (via the
    // *ngIf="showContent" toggle) does not leave a duplicate handler firing
    // loadSidebarLinks/GetMenuBasedOnRole on every NavigationEnd.
    this.routerEventsSub?.unsubscribe();
    this.routerEntitySub?.unsubscribe();
  }

  setNavName() {
    this.ClientId = `[${this.userService.getClientId()}]`;
    this.CustomerName = this.userService.getClientName();
  }
  gotoEntityDashboard() {
    this.ClientId = '';
    this.CustomerName = '';
    this.router.navigate(['/EntityDashboard']);
  }

  gotoClientDashboard() {
    this.router.navigate(['/ClientDashboard']);
  }

  /**
   * True while this is an impersonated client-portal session that can be returned from.
   *
   * The role is checked as well as the backup: forceLogout() deliberately preserves
   * 'userDataBackup' across a session wipe so a dying client session cannot destroy the
   * original credentials, which means the backup can briefly outlive the impersonation.
   * Requiring a client-portal role too keeps this control out of normal internal sessions.
   */
  get isImpersonating(): boolean {
    return this.userService.isImpersonating() && (this.Role === 'HMGR' || this.Role === 'HAPPR');
  }

  /**
   * Leave the client portal and go back to the internal screen the user came from.
   *
   * No session work happens here: navigating to an internal route is denied for the
   * impersonated role, and auth-route.guard's denyOrReturnFromImpersonation() picks that
   * up, restores the original session and hard-navigates to the same URL.
   */
  goBackToInternal() {
    this.ClientId = '';
    this.CustomerName = '';
    this.router.navigateByUrl(this.userService.getInternalReturnUrl() || '/EntityDashboard');
  }
  downloadClientPortalHelp() {
    const link = document.createElement('a');
    link.href = '/assets/docs/Client-Portal-Help-v2.1.pdf';
    link.download = 'RegAuto Labour - Client Portal Help v2.1.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // @HostListener('window:beforeunload', ['$event'])
  // onBeforeUnload(event: Event) {
  //    this.logOut();
  // }
  logOut() {
    this.ClientId = '';
    this.CustomerName = '';
    this.navLinksService.LogoutJTIUpdate(this.token).subscribe({
      next: () => {
        sessionStorage.clear();
        if (environment.isLogoOutFromLive === '1') {
          window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
        } else {
          window.location.href = '/Login';
        }
      },
      error: () => {
        // Optionally handle error 
        sessionStorage.clear();
        if (environment.isLogoOutFromLive === '1') {
          window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
        } else {
          window.location.href = '/Login';
        }
      }
    });
  }
  loadSidebarLinks() {
    if (this.Role && this.CustomerId && this.SpID && sessionStorage.getItem('IsRedirectToMW') != '1' && sessionStorage.getItem('IsRedirectToHM') != '1') {
      // Cache-first via NgRx: the menu only depends on Role/CustomerId/ServiceProvider/UserId
      // (fixed for the session), so the HTTP call fires once and every later navigation is
      // served from the store. The endpoint string (incl. query params) is the cache key.
      const hmacPayload = { Role: this.Role, CustomerId: this.CustomerId, ServiceProvider: this.SpID, UserId: this.userId };
      const endpoint = `/api/MenuHandler/GetMenuBasedOnRole?Role=${this.Role}&CustomerId=${this.CustomerId}&ServiceProvider=${this.SpID}&UserId=${this.userId}`;
      this.reduxApiHandler.fetchWithCache<any>(endpoint, hmacPayload).subscribe({
        next: (cached) => {
          // Generic effect wraps array responses as { data, total }; unwrap and clone so
          // setSideBarChild's mutations don't touch the cached store object.
          const menu = cached?.data ?? cached;
          this.setSideBarChild(menu ? JSON.parse(JSON.stringify(menu)) : []);
        },
        error: (error) => {
          console.error('Error fetching sidebar data', error);
          // Defense-in-depth against a tampered login RESPONSE role (e.g. Burp changing
          // PERF -> another role). GetMenuBasedOnRole is role-validated server-side against
          // the SIGNED JWT claim (ClaimVerificationMiddleware), so a manipulated role no
          // longer matches the token and the server returns 401. Don't leave the user on a
          // mismatched shell/route — force logout, which clears the session and redirects to
          // the correct login (the live logout page when isLogoOutFromLive === '1', else
          // /Login), and revokes the token's JTI server-side.
          // 403 only. A 401 here is an EXPIRED access token, which the auth interceptor
          // already refreshes and retries — and which force-logs-out by itself if the refresh
          // genuinely fails. Logging out on 401 here turned that recoverable blip into a hard
          // logout, and the sidebar reloads on nearly every navigation, so it fired often.
          if (error?.status === 403) {
            this.logOut();
          }
        }
      });
    } else {
      console.warn("Missing Role, CustomerId or SpID");
    }
  }


  setSideBarChild(nav: any) {
    this.navLinks = this.buildSidebarTree(nav || []);
    this.cd.detectChanges(); // Ensure the view updates
  }
  toggleSidebar(open: boolean) {
    if (this.sidebar.nativeElement) {
      const sidebarElement = this.sidebar.nativeElement as HTMLElement;
      if (open) {
        sidebarElement.classList.add('active');
      } else {
        sidebarElement.classList.remove('active');
      }

      this.sidebarActive = open;

      if (this.sidebarActive) {
        this.toggleimg = '../assets/vectors/SidebarToggleoff.svg'
        this.logoImageUrl = './assets/Images/TeamLease-small.png';
        this.logoImageClass = 'nav-close-logo';
      } else {
        this.toggleimg = '../assets/vectors/SidebarToggle.svg'
        this.logoImageUrl = './assets/Images/TeamLeaseRegtech_Logo_new.png';
        this.logoImageClass = 'nav-open-logo';
      }

      const sidebarBtn = document.querySelector('.sidebarBtn') as HTMLElement;
      if (sidebarBtn) {
        if (this.currentRoute === '/EntityDashboard' || this.currentRoute === '/CustomerMaster' || this.currentRoute === '/UserMaster' || this.currentRoute === '/CustomerUserMapping' || this.currentRoute === '/ListOfEntities') {
          this.ClientId = '';
          this.CustomerName = '';
          if (sidebarElement.classList.contains('active')) {
            sidebarBtn.classList.replace('bx-menu-alt-right', 'bx-menu');
          } else {
            sidebarBtn.classList.replace('bx-menu', 'bx-menu-alt-right');
          }
        } else {
          sidebarBtn.classList.replace('bx-menu', 'bx-menu-alt-right');
        }
      }

      const containerContent = document.querySelector('.container-content') as HTMLElement;
      if (containerContent) {
        if (sidebarElement.classList.contains('active')) {
          containerContent.classList.add('sidebar-active');
        } else {
          containerContent.classList.remove('sidebar-active');
        }
      }
    }
  }

  AssignSession() {
    this.firstName = this.userService.getFirstName();
    this.lastName = this.userService.getLastName();
    this.userId = this.userService.getUserId();
    this.Role = this.userService.getRole();
    this.CustomerId = this.userService.getCustomerId();
    this.ClientId = this.userService.getClientId();
    this.CustomerName = this.userService.getClientName();
    this.SpID = this.userService.getServiceProviderID();
    this.token = this.userService.getAccessToken();
  }

  // Division-layer client-portal users can multi-select entities on the
  // dashboard; the applied selection is stored as a comma-joined clientId.
  // Downstream feature pages support only a single entity context, so
  // navigating away with more than one entity selected must be blocked.

  private isMultipleEntitySelected(): boolean {
    const clientId = this.userService.getClientId();
    return Boolean(clientId && clientId.includes(','));
  }

  // Division-layer client-portal customers (CheckDivisionAvailability = true) select
  // entities via the on-page dropdowns, so the header entity label must be hidden.
  get isDivisionAvailable(): boolean {
    return sessionStorage.getItem('divisionAvailability') === 'true';
  }

  // Hide the header entity label only for the roles that pick entities from the header
  // dropdowns on a division-layer customer. Every other role (PERF, DADMN, ...) is tied
  // to the one entity it selected on the Entity Dashboard and must keep seeing it, even
  // when that customer has divisions enabled.
  get hideEntityLabel(): boolean {
    return this.isDivisionAvailable && ENTITY_DROPDOWN_ROLES.includes(this.Role);
  }

  onSubSidebarLinkClick(linkName: string, navLink: string, node?: any) {

    if (!this.userService.getClientId() && (this.Role === 'HMGR' || this.Role === 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Entity Selection is Required', alertVisible: 'error' };
      return;
    }
    if (this.isMultipleEntitySelected() && (this.Role === 'HMGR' || this.Role === 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Please select only one entity', alertVisible: 'error' };
      return;
    }
    if (linkName === 'Registration Repository') {
      navLink = '/RegistrationsRepository';
    }
    else if (linkName === 'MIS Documents') {
      navLink = '/LC_MIS';
    }
    else if (linkName === 'Employee ESIC') {
      navLink = '/LC_ESIC';
    }
    else if (linkName === 'Critical Documents') {
      navLink = '/CriticalDocuments';
    }

    this.menuService.setSelectedMenu(linkName);
    this.menuService.selectedMenu$.subscribe(menu => {
      this.selectedMenu = menu;

    });
    if (this.selectedMenu == 'Dashboard') {
      this.selectedMenu = 'My Dashboard'
    }
    this.selectedNavLink = node ?? this.navLinks.find(link => link.name === this.selectedMenu);
    if (this.Role == 'HMGR' || this.Role == 'HAPPR' || this.Role == 'HMGMT') {
      this.CaptureClientPortalPageWiseDetails()
    }
    sessionStorage.removeItem('currentFolderID')
    sessionStorage.removeItem('breadcrumbs')
    sessionStorage.removeItem('items')
    this.router.navigate([navLink]);
  }

  onSidebarLinkClick(linkName: string, navLink: string, node?: any) {


    const IsProductMappingApplicable = sessionStorage.getItem('IsProductMappingApplicable')
    if (linkName == 'Home' && IsProductMappingApplicable == '1') {
      //location.replace('https://login.teamleaseregtech.com/ProductMapping/MappingStructure');
      window.location.href = "https://login.teamleaseregtech.com/ProductMapping/MappingStructure";
      return;
    } else if (linkName == 'Home' && (this.Role == 'HMGR' || this.Role == 'HAPPR') && IsProductMappingApplicable == '1') {
      window.location.href = "https://login.teamleaseregtech.com/ProductMapping/MappingStructure";
      return;
    } else if ((this.Role == 'HMGR' || this.Role == 'HAPPR') && linkName == 'Home') {
      this.router.navigate(['/ClientDashboard']);
      return;
    }
    this.collapseRootGroups('sublist', node);
    if (!this.userService.getClientId() && (this.Role === 'HMGR' || this.Role === 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Entity Selection is Required', alertVisible: 'error' };
      return;
    }
    if (this.isMultipleEntitySelected() && (this.Role === 'HMGR' || this.Role === 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Please select only one entity', alertVisible: 'error' };
      return;
    }
    if (linkName === 'Registration Repository') {
      navLink = '/RegistrationsRepository';
    }
    else if (linkName === 'MIS Documents') {
      navLink = '/LC_MIS';
    }
    else if (linkName === 'Employee ESIC') {
      navLink = '/LC_ESIC';
    }
    else if (linkName === 'Critical Documents') {
      navLink = '/CriticalDocuments';
    }
    else if ((this.Role == 'DADMN' || this.Role == 'RVW1') && linkName == 'My Documents') {
      navLink = '/DigitalSignature';
    }
    else if ((this.Role == 'DADMN') && linkName == 'Onboard Employee') {
      navLink = '/DOLReactivation';
    }


    if (this.selectedMenu == 'Dashboard') {
      this.selectedMenu = 'My Dashboard'
    }
    this.selectedNavLink = this.navLinks.find(link => link.name === this.selectedMenu);

    if (this.Role == 'HMGR' || this.Role == 'HAPPR' || this.Role == 'HMGMT') {
      this.CaptureClientPortalPageWiseDetails()
    }
    sessionStorage.removeItem('currentFolderID')
    sessionStorage.removeItem('breadcrumbs')
    if (node?.hasChildren) {
      this.toggleRootGroup(node);
    }
    this.menuService.setSelectedMenu(linkName);

    this.menuService.selectedMenu$.subscribe(menu => {
      this.selectedMenu = menu;

    });
    if (navLink) {
      this.router.navigate([navLink]);
    }
  }

  onSidebarSubLinkClick(linkName: string) {

    if (linkName === 'Existing License') {
      this.router.navigate(['/ExistingRegistrationLicense'])
    } else if (linkName === 'New License Request') {
      this.router.navigate(['/NewRegistrationLicense'])
    } else if (linkName === 'Manage Employee') {
      this.router.navigate(['/ManageEmployee'])
    } else if (linkName === 'Employee CTC') {
      this.router.navigate(['/EmployeeCTCMaster'])
    } else if (linkName === 'Employee Report') {
      this.router.navigate(['/EmployeeMasterReport'])
    }

  }
  changePassword() {
    this.router.navigate(['/ForgetPassword']);
  }
  closeAlert() {
    this.alertData = { alertMessage: '', alertVisible: '' }
  }

  CaptureClientPortalPageWiseDetails() {

    const payload = {
      userID: this.userService.getUserId(),
      clientID: this.userService.getClientId(),
      roleID: this.userService.getRoleId().toString(),
      flag: this.selectedNavLink?.menuID || ''
    }

    this.loginService.CaptureClientPortalPageWiseDetails(payload).subscribe({
      next: (response) => {
        if (response.status === 200) {
        } else {
          console.error('Error capturing Client Portal Login Details');
        }
      },
      error: (error) => {
        console.error('Error capturing Client Portal Login Details', error);
      }
    });
  }
  // Download Help Document
  openHelpDocument(): void {
    if (this.loading) { return; }
    this.loading = true;
    this.CommonService.GetHelpDocument().subscribe({
      next: (blob: Blob) => {
        this.helpDocBlob = blob;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.alertData = { alertMessage: 'Unable to load help document. Please try again.', alertVisible: 'error' };
        console.error('Error fetching help document', error);
      }
    });
  }

  closeHelpDocument(): void {
    this.helpDocBlob = null;
  }
}
